/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";
import {
  HeaderService,
  IHeaderMethods,
  FooterService,
  IFooterMethods,
  FeatureSectionService,
  IFeatureSectionMethods,
  AppCardListService,
  IAppCardListMethods,
  StaticPageContentService,
  IStaticPageContentMethods,
  IUpdateKycMethods,
  UpdateKycService,
} from "./components";

export type HoldersListAgent = IHeaderMethods &
  IFeatureSectionMethods &
  IFooterMethods &
  IAppCardListMethods &
  IStaticPageContentMethods &
  IUpdateKycMethods;

const getPlugins = () => {
  return [
    new HeaderService(),
    new FeatureSectionService(),
    new FooterService(),
    new AppCardListService(),
    new StaticPageContentService(),
    new UpdateKycService(),
  ];
};

export const getAgent = () => {
  return createAgent<HoldersListAgent>({
    plugins: getPlugins(),
  });
};
